export const INTEGRATOR_SETTINGS_ID = "integrator-settings";

export const INTEGRATOR_FREQUENCY_PERIODICITIES = [
  "days",
  "weeks",
  "months",
] as const;

export type IntegratorFrequencyPeriodicity =
  (typeof INTEGRATOR_FREQUENCY_PERIODICITIES)[number];

export const INTEGRATOR_DEFAULT_IS_SEARCHABLE_VALUES = [
  "true",
  "false",
  "notSet",
] as const;

export type IntegratorDefaultIsSearchable =
  (typeof INTEGRATOR_DEFAULT_IS_SEARCHABLE_VALUES)[number];

export interface IntegratorFrequency {
  /** Inclusive start of the schedule, calendar date `YYYY-MM-DD`. */
  startDate: string;
  periodicity: IntegratorFrequencyPeriodicity;
  /** How many `periodicity` units between automatic runs. Whole number ≥ 1. */
  interval: number;
}

/**
 * Client mirror of the serverless IntegratorSettings singleton.
 * Consumed by the Services/IntegratorSettings mirror service.
 */
export default interface IIntegratorSettings {
  id: typeof INTEGRATOR_SETTINGS_ID;
  frequency: IntegratorFrequency;
  defaultIsSearchable: IntegratorDefaultIsSearchable;
  /** Next automatic-run instant, epoch ms. Server-owned. */
  nextExecutionDate?: number;
  createdDate?: number;
  updatedDate?: number;
}
